import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EButtonType } from '../../data-types/button.enum';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyService } from '../../services/company.service';
import { LocalStorageService } from '../../cowing-core.module';
import { EStorageType } from '../../data-types/storage.enum';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/state/app.state';
import { closeLoadingAction, showLoadingAction } from '../../store/actions/loading.action';
import { showAlertAction } from '../../store/actions/alert.action';


@Component({
  selector: 'cowing-form',
  templateUrl: './company-employee-form.component.html',
  styleUrls: ['./company-employee-form.component.scss'],
})
export class CompanyEmployeeFormComponent implements OnInit {
  public EButtonType = EButtonType;
  registerForm: FormGroup;
  submitted = false;
  companyId;
  newEmployee;
  zipPattern: any = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;
  @Output('statusModal') statusModal: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private companyService: CompanyService,
    private _store: Store<IAppState>,
  ) {
    this.companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this.registerForm = this.formBuilder.group(
      {
        name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        total_cowings: [200, Validators.required],
        language: ['', Validators.required],
        cp: [null, [Validators.required, Validators.pattern(this.zipPattern)]],
        employee_id: ['']
      }
    );
  }

  ngOnInit(): void {}

  get form() {
    return this.registerForm.controls;
  }

  async onSubmit() {
    this._store.dispatch(showLoadingAction({}));
    try {
      this.submitted = true;
      if (this.registerForm.invalid) {
        return;
      }
      this.statusModal.emit(false);
      this.newEmployee = this.registerForm.value;
      await this.companyService.putEmployeesToCompany(
        [this.newEmployee], this.companyId
      );
      this._store.dispatch(closeLoadingAction({}));
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this.translate.instant('company.employees.add_employee.form.message_success'),
            title: this.translate.instant('login.done'),
            type: 'alertAddEmployee',
          },
        })
      );
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant('general.expired')
                : e.data.error,
            title: this.translate.instant('general.caution'),
            type: 'error',
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  onReset() {
    window.location.reload();
  }
}
